import {
  useTabsActions,
  useTabsView,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/tabs-context';
import { useTrackedCallback } from '@paradigm/features/src/analytics';
import Tabs from './Tabs';

export default function RfqTabs() {
  const { tabs, activeTab } = useTabsView();
  const tabActions = useTabsActions();
  const addTab = useTrackedCallback('add tab', tabActions.addTab);
  const deleteTabById = useTrackedCallback(
    'remove tab',
    tabActions.deleteTabById,
  );
  const deleteAllTabs = useTrackedCallback(
    'remove all tabs',
    tabActions.deleteAllTabs,
  );
  const reorderTab = useTrackedCallback('reorder tabs', tabActions.reorderTab);
  const viewTab = useTrackedCallback('select tab', tabActions.viewTab);

  return (
    <Tabs
      tabs={tabs}
      activeTab={activeTab}
      deleteTab={deleteTabById}
      deleteAllTabs={deleteAllTabs}
      reorderTab={reorderTab}
      viewTab={viewTab}
      addTab={addTab}
    />
  );
}
